import styled from 'styled-components';

import { Select } from '@nhl/nhl-breakaway-ui';

export const StyledSelect = styled(Select)`
    .MuiListItem-root {
        height: 56px; 
    }
`
